import { NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { DevoPipelinePageService } from '../devo-pipeline.page.service';
import { DevoPipelineOpportunitiesViewPart } from './opportunities/devo-pipeline-opportunities-view.part';
import { DevoPipelineStaffViewPart } from './staff/devo-pipeline-staff-view.part';


@Component({
	selector: 'devo-pipeline-views-part',
	standalone: true,
	imports: [
		DevoPipelineOpportunitiesViewPart,
		DevoPipelineStaffViewPart,
		DroplistWidget,
		NgSwitch,
		NgSwitchCase
	],
	templateUrl: './devo-pipeline-views.part.html',
})
export class DevoPipelineViewsPart implements OnInit {

	public service = inject(DevoPipelinePageService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}